import { render, staticRenderFns } from "./dishModelAdmin.vue?vue&type=template&id=6918d182&scoped=true&"
import script from "./dishModelAdmin.vue?vue&type=script&lang=js&"
export * from "./dishModelAdmin.vue?vue&type=script&lang=js&"
import style0 from "./dishModelAdmin.vue?vue&type=style&index=0&id=6918d182&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6918d182",
  null
  
)

export default component.exports